import cn from 'classnames'
import React from 'react'
import SalesAssetPreview from '../assetpreview/SalesAssetPreview'

export const SalesList = (props) => {
    const assets = props['assets']
    const search = props['search']
    const id = props['id']
    const page = props['page']

    return (
        <div
            className={cn(
                {
                    'grid sm:gap-4 gap-2 grid-cols-1 xsse:grid-cols-2 sm1:grid-cols-3 md:grid-cols-3 md1:grid-cols-4 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-6 3xl:grid-cols-7 4xl:grid-cols-7 text-center sm:mx-4 mx-2':
                        search !== 'tradable',
                },

                {
                    'grid grid-cols-1 md:grid-cols-3 gap-x-5':
                        search === 'tradable',
                },
            )}
            id={id ? id : ''}
        >
            {assets?.map((asset, index) => (
                <SalesAssetPreview
                    index={index}
                    key={`${asset.listingId}_${index}`}
                    sale={asset}
                    page={page}
                />
            ))}
        </div>
    )
}
